import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function FrontNav() {
  const user = useSelector((state) => state.user.user);

  return (
    <section className="pt-8 pt-md-8">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-4">
            <h2 className="fw-bold">
              <FormattedMessage id="front.rp_module.enrolltitle" />
            </h2>
            <p className="fs-lg text-muted mb-5">
              <FormattedMessage id="front.rp_module.enrollsubtitle" />
            </p>
            {user ? (
              ''
            ) : (
              <Link to={'/rosters/apply'} className="btn btn-primary mb-6 mb-md-0 lift">
                <FormattedMessage id="front.rp_module.enrollbtn" />{' '}
                <i className="fe fe-arrow-right ms-3" />
              </Link>
            )}
          </div>
          <div className="col-12 col-md-8">
            <div className="col-12">
              <div className="row gx-4">
                <div className="col-4">
                  <img
                    className="img-fluid rounded shadow-lg"
                    src="/assets/img/cdmis/gal5-9716ab657f64b1c98c529cf7e4f8fcc12ff02f44bcd8c53961613a8f78be1d60.webp"
                    alt="Resource Person Training Sessions"
                  />
                </div>
                <div className="col-3">
                  <img
                    className="img-fluid rounded shadow-lg mb-4"
                    src="/assets/img/cdmis/gal3-9e4f42518d549365f0fedb62e34621c91b3d165d9e8b2fa48ccd26945df8b15e.webp"
                    alt="Resource Person Training Sessions"
                  />
                  <img
                    className="img-fluid rounded shadow-lg"
                    src="/assets/img/cdmis/gal4-22a4b4f818eb2482f3a85dc50d2a0df96f75e569e6d25b07e7bd7241465938b4.webp"
                    alt="Resource Person Training Sessions"
                  />
                </div>
                <div className="col-5">
                  <div className="row gx-3 mb-4">
                    <div className="col-6">
                      <img
                        className="img-fluid rounded shadow-lg"
                        src="/assets/img/cdmis/gal7-04209b6b9ef6be43e1943f051988498fc157fb1125c8469561cedab7e5731783.webp"
                        alt="Resource Person Training Sessions"
                      />
                    </div>
                    <div className="col-6">
                      <img
                        className="img-fluid rounded shadow-lg"
                        src="/assets/img/cdmis/gal11-52fdcd6b6831a9d395b0a90389e961ef076f441877a959f699a65e8b858f475b.webp"
                        alt="Resource Person Training Sessions"
                      />
                    </div>
                  </div>
                  <img
                    className="img-fluid rounded shadow-lg"
                    src="/assets/img/cdmis/gal2-f377db05e23bf2d737b42b84385ea30fa5df411395c9cd7b9df5928dc1602d3f.webp"
                    alt="Resource Person Training Sessions"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
